import { AxiosPromise } from 'axios';
import httpClient from 'api/httpClient';
import {
  EntitlementAuditTrailParams,
  EntitlementAuditTrailResponse,
  EntitlementsForBusinessResponse,
  GrantEntitlementsPayload,
  RevokeEntitlementsPayload,
} from 'types/entitlements/entitlements';

/**
 * ⚠️ Answers **404** for a business that does not exist, where its sibling routes under
 * `/super-admin/businesses/:businessId/*` answer 400.
 */
export const getEntitlementsForBusiness = (
  businessId: number,
): AxiosPromise<EntitlementsForBusinessResponse> =>
  httpClient({
    method: 'GET',
    url: `/super-admin/businesses/${businessId}/entitlements`,
  });

export const grantEntitlements = ({
  businessId,
  ...data
}: GrantEntitlementsPayload): AxiosPromise<void> =>
  httpClient({
    method: 'POST',
    url: `/super-admin/businesses/${businessId}/entitlements/grant`,
    data,
  });

export const revokeEntitlements = ({
  businessId,
  ...data
}: RevokeEntitlementsPayload): AxiosPromise<void> =>
  httpClient({
    method: 'POST',
    url: `/super-admin/businesses/${businessId}/entitlements/revoke`,
    data,
  });

/**
 * Every grant and revocation of the business, newest first, 50 a page (COS-4953). A `storeId`
 * outside the business answers 404, never an empty page.
 */
export const getEntitlementAuditTrail = ({
  businessId,
  page,
  storeId,
}: EntitlementAuditTrailParams): AxiosPromise<EntitlementAuditTrailResponse> =>
  httpClient({
    method: 'GET',
    url: `/super-admin/businesses/${businessId}/entitlements/audit-trail`,
    params: { page, storeId },
  });
